import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function FullscreenOffIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={color}>
        <path d="m3.15005 14.3998v3.8033c1.40554-.1126 3.70484-.2634 6.45-.3246v1.3488c-3.30981.0748-5.95987.2832-7.13789.3891l-.06621.0023c-.32623-.0058-.5959-.2722-.5959-.6064v-4.6125z" />
        <path d="m22.2 19.0123c0 .3342-.2696.6006-.5959.6064l-.0662-.0023c-1.178-.1059-3.828-.3143-7.1379-.3891v-1.3488c2.7452.0612 5.0445.212 6.45.3246v-3.8033h1.35z" />
        <path d="m21.5379 4.38319c.3551-.0319.6621.24761.6621.60411v4.6125h-1.35v-3.80391c-1.4055.11263-3.7048.26322-6.45.32461v-1.34824c3.3099-.07477 5.9599-.2832 7.1379-.38907z" />
        <path d="m2.46216 4.38261c1.17805.10598 3.82811.31477 7.13789.38965v1.34824c-2.74515-.06151-5.04444-.21245-6.45-.3252v3.8045h-1.35v-4.61309c.00012-.35645.30707-.63599.66211-.6041z" />
      </g>
    </SVGWrapper>

  );
}

export default FullscreenOffIcon;
